import React from "react";

/**
 * Suspense Fallback Component for Route-Level Code Splitting
 * 
 * Displays a simple loading spinner while route components are being loaded.
 * Uses Bootstrap spinner to match existing UI patterns.
 */
const RouteSuspenseFallback: React.FC = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="text-center">
        <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <h5 className="mt-3 text-muted">Loading page...</h5>
      </div>
    </div>
  );
};

export default RouteSuspenseFallback;

